import { defineStyleConfig } from '@chakra-ui/react';

export const Badge = defineStyleConfig({
  baseStyle: {
    borderRadius: 'md',
    textTransform: 'initial',
    px: 2,
  },
  sizes: {},
  variants: {},
  defaultProps: {},
});
